import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react'
import s from './styles.module.scss'
import cn from 'clsx'
import { CloseIcon } from '@App/static/icons/ArrowIcons'

type SideBarProps = {
  headerContent?: string | ReactNode
  contentClassName?: string
  onClose?: () => void
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const SideBar = ({ className, headerContent, children, contentClassName, onClose }: SideBarProps) => {
  return (
    <div className={cn(s.container, className)}>
      <div className={s.header}>
        <div className={s.side}></div>
        <div className={s.content}>{headerContent}</div>
        <div className={s.side}>
          <CloseIcon className={s.icon} onClick={() => onClose?.()} />
        </div>
      </div>
      <div className={cn(s.content, contentClassName)}>{children}</div>
    </div>
  )
}
